<template>
  <div>
    <b-table id="table_classement" hover small responsive :items="classement" :fields="fields" v-if="$store.state.classement_type ==='Club' || $store.state.classement_type ==='Entreprise'">
      <template #cell(name)="data">
        <b>{{ data.item.name }}</b>
      </template>
      <template #cell(points)="data">
        <b>{{ data.item.points }}</b>
      </template>
      <template #cell(fiche)="data">
        <b-button class="btn_fiche" @click="openFicheOrga(data.item.id)">
          <b-icon
          icon="plus-square-fill"
          aria-hidden="true"
          
        />
        </b-button>
      </template>
    </b-table>
        <b-table id="table_classement" hover small responsive :items="classement" :fields="performance_fields" v-else>
      <template #cell(name)="data">
        <b>{{ data.item.name }}</b>
      </template>
      <template #cell(performance_points)="data">
        <b>{{ data.item.performance_points }}</b>
      </template>
      <template #cell(fiche)="data">
        <b-button class="btn_fiche" @click="openFicheOrga(data.item.id)">
          <b-icon
          icon="plus-square-fill"
          aria-hidden="true"
          
        />
        </b-button>
      </template>
    </b-table>
    <p v-if="classement.length===0"><b>Il n'y a pas encore de participant à ce challenge</b></p>
  </div>
</template>

<script>
export default {
  props: ["classement"],
  data() {
    return {
            fields: [
        { key: "classement", label: "Clt", sortable: true },
        { key: "name", label: "Nom", sortable: true },
        { key: "points", label: "Points", sortable: true },
        { key: "nb_coureurs", label: "Nb coureurs" },

        {
          key: "nb_participations",
          label: "Nb participations",
          sortable: true,
        },
        { key: "fiche", label: "Fiche" },
      ],
      performance_fields: [
        { key: "performance_classement", label: "Clt", sortable: true },
        { key: "name", label: "Nom", sortable: true },
        { key: "performance_points", label: "Points", sortable: true },
        { key: "performance_nb_coureurs", label: "Nb coureurs" },

        {
          key: "performance_nb_participations",
          label: "Nb participations",
          sortable: true,
        },
        { key: "fiche", label: "Fiche" },
      ],
    };
  },
  methods: {
    openFicheOrga(id) {
      var fiche_path = "organisation/" + id;
      this.$router.push({ path: fiche_path });
    },
  },
};
</script>

<style lang="scss">

</style>
